// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__tx+Zl","tabs__button":"Tabs_tabs__button__mjwft","tabs__button--active":"Tabs_tabs__button--active__i2qL6"};